import { Suspense, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { MdDeleteForever } from "react-icons/md";
import { RiEditFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import ToolTip from "../../../Components/CustomComponents/ToolTip";
import EditMentalHealthModal from "../../../Components/Modals/EditMentalHealthModal";
// import {
//   useDeleteDietaryRestrictionMutation,
//   useGetAllDietaryRestrictionsQuery,
// } from "../../../Data/services/dietaryRestrictionApi";
import Toast, { SuccessToast } from "../../../Hooks/useToast";
// import {
//   useDeleteMentalHealthMutation,
//   useGetAllMentalHealthQuery,
// } from "../../../Data/services/mentalHealthApi";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../lib/apiClient";
import { mentalHealthService } from "../../../Services/mentalHealthService";

export const useMentalHealthManagement = () => {
  const { control, watch } = useForm({
    defaultValues: {
      type: "",
    },
  });
  const type = watch("type");
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [dataFetched, setDataFetched] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const filterData = [
    {
      value: "all",
      label: "All",
    },
    {
      value: 10,
      label: "GENERAL",
    },
    {
      value: 20,
      label: "FAMILY",
    },
  ];

  // const { data, isLoading, isFetching, refetch } = useQuery({
  //   queryKey: ["mentalHealths", currentPage, pageSize, searchQuery, type],
  //   queryFn: () => {
  //     const params = new URLSearchParams({
  //       search: searchQuery.length >= 3 ? searchQuery : "",
  //       limit: pageSize,
  //       page: currentPage,
  //       type: type === "all" || type === undefined ? "" : type,
  //     });
  //     return apiClient.get(`mental-healths?${params.toString()}`);
  //   },
  //   staleTime: Infinity,
  // });

  const { data, isLoading, isFetching, refetch } = mentalHealthService.useList(
    {
      search: searchQuery.length >= 3 ? searchQuery : "",
      limit: pageSize,
      page: currentPage,
      type: type === "all" || type === undefined ? "" : type,
    },
    {
      staleTime: Infinity,
    }
  );

  useEffect(() => {
    if (data) {
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
      if (data.data.length === 0) {
        setIndicationMessage("No categories found");
      }
    }
  }, [data]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleEditModalOpen = () => setEditModal(true);
  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleDeleteModalOpen = () => setDeleteModal(true);
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleAddCategory = () => {
    setEditedData(null);
    handleEditModalOpen();
  };

  // const { mutate: deleteMentalHealth, isPending: isDeleting } = useMutation({
  //   mutationFn: (id) => apiClient.delete(`mental-healths/${id}`),
  //   onSuccess: (data) => {
  //     if (data.code === 200) {
  //       handleDeleteModalClose();
  //       queryClient.invalidateQueries(["mentalHealths"]);
  //       SuccessToast(data.message);
  //     }
  //   },
  //   onError: (error) => {
  //     Toast(error.message, "error");
  //   },
  // });

  const { mutate: deleteMentalHealth, isPending: isDeleting } =
    mentalHealthService.useDelete();

  const deleteData = async (id) => {
    deleteMentalHealth(id, {
      onSuccess: (data) => {
        if (data.code === 200) {
          refetch();
          handleDeleteModalClose();
          SuccessToast(data.message);
        }
      },
      onError: (error) => {
        Toast(error.message, "error");
      },
    });
  };

  function indication() {
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Mental Health Name",
      headerAlign: "left",
      align: "left",
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => {
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <ToolTip placement={"top"} content={"Edit"}>
                <div
                  className={` d-flex justify-content-center align-items-center bg-success-hover rounded-3 p-2 mx-2 `}
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleEditModalOpen(true);
                  }}
                >
                  <span
                    className={`align-items-center d-flex justify-content-center `}
                  >
                    <RiEditFill />
                  </span>
                </div>
              </ToolTip>
              <ToolTip placement={"top"} content={"Delete"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleDeleteModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center`}>
                    <MdDeleteForever />
                  </span>
                </div>
              </ToolTip>
            </div>
          );
        }
      },
    },
  ];

  const Modals = () => <></>;

  return {
    searchQuery,
    handleSearchChange,
    rowData,
    columns,
    indication,
    totalRecords,
    totalPages,
    pageSize,
    currentPage,
    setCurrentPage,
    setPageSize,
    refetch,
    dataFetched,
    isFetching,
    isLoading,
    Modals,
    handleAddCategory,
    filterData,
    control,
    deleteModal,
    editedData,
    handleDeleteModalClose,
    deleteData,
    isDeleting,
    editModal,
    handleEditModalClose,
  };
};
